import { Tooltip, makeStyles } from '@material-ui/core';
import { ProjectSetup } from '../../api/types';

const READY_COLOR = 'rgb(114, 175, 80)';
const LIMITED_COLOR = 'rgb(255, 192, 85)';

const useStyles = makeStyles(theme => ({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.3rem',
    padding: theme.spacing(0.125, 0.75),
    borderRadius: '0.75rem',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.secondary,
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.02em',
    lineHeight: 1.6,
    whiteSpace: 'nowrap',
    cursor: 'default',
  },
  dot: {
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '50%',
    flexShrink: 0,
  },
}));

/**
 * radar's label for how well a project fits what it measures today: `ready`
 * (measured as designed) or `limited` (measured with known gaps, listed in the
 * tooltip). Only the dot carries colour — the chip is a label, not a score.
 */
export const SetupChip = ({ setup }: { setup: ProjectSetup }) => {
  const classes = useStyles();
  const ready = setup.status === 'ready';
  const explanation = ready
    ? 'This project fits what radar measures today: its Product and Delivery numbers are complete.'
    : `Measured with known gaps: ${
        setup.notes.length ? setup.notes.join('; ') : 'see the metric rows'
      }.`;
  return (
    <Tooltip
      title={
        <span style={{ fontSize: '0.875rem', lineHeight: 1.45 }}>
          {explanation}
        </span>
      }
      arrow
    >
      <span
        className={classes.chip}
        data-testid={`setup-chip-${setup.status}`}
        aria-label={`radar ${setup.status}. ${explanation}`}
      >
        <span
          className={classes.dot}
          style={{ backgroundColor: ready ? READY_COLOR : LIMITED_COLOR }}
        />
        {ready ? 'radar: ready' : 'radar: limited'}
      </span>
    </Tooltip>
  );
};
